<div class="search-autocomplete" [style.width.px]="config.width">
  <div class="search-autocomplete__open-btn-wrapper">
    <ng-container *ngIf="!this.value; else withvalue">
      <qr-button
        [config]="buttonOpen"
        [class.btn-error]="hasError"
        (click)="onOpen()"
      ></qr-button>
    </ng-container>
    <ng-template #withvalue>
      <div class="search-autocomplete__btn-select" (click)="onOpen()">
        <p>{{ this.value }}</p>
        <qr-icon [name]="ICON_CLOSE" [color]="COLOR_GREY_700"></qr-icon>
      </div>
    </ng-template>
  </div>
  <div class="search-autocomplete__content" *ngIf="!this.isClosed">
    <div class="search-autocomplete__searcher">
      <qr-input
        [config]="inputSearch"
        [value]="this.inputText"
        (valueChange)="inputSearchChange($event)"
      ></qr-input>
    </div>
    <div class="search-autocomplete__options">
      <ng-container
        *ngIf="
          this.filteredChips.length > 0 && config.canCreateNewOption;
          else nooptions
        "
      >
        <div
          *ngFor="let chip of this.filteredChips"
          class="search-autocomplete__chip"
          [ngClass]="{
            'search-autocomplete__chip--selected': this.selection === chip.text
          }"
          (click)="onClickChip(chip.text)"
        >
          <p
            class="search-autocomplete__chip-text"
            [ngClass]="{
              'search-autocomplete__chip-text--selected':
                this.selection === chip.text
            }"
            [innerHTML]="chip.highlighted"
          ></p>
        </div>
      </ng-container>
      <!-- No hay opciones para la busqueda -->
      <ng-template #nooptions>
        <p class="search-autocomplete__no-results">
          No se encontraron resultados para <br />
          <b>{{ this.inputText }}</b>
        </p>
        <div
          class="search-autocomplete__add-option"
          (click)="onSelectionNew()"
          [class.search-autocomplete__add-option--selected]="manualSelection"
        >
          <p>Agregar nueva opción</p>
          <div
            class="search-autocomplete__add-button"
            [class.search-autocomplete__add-button--selected]="manualSelection"
          >
            <p>{{ this.inputText }}</p>
          </div>
        </div>
      </ng-template>
    </div>
    <div class="search-autocomplete__actions">
      <qr-button
        [isDisabled]="!this.selection && !this.manualSelection"
        [config]="buttonSelect"
        (click)="onSelect()"
      ></qr-button>
    </div>
  </div>
</div>
